import { lazy } from 'solid-js'
import { ROUTES } from '../router-utils.js'
import { messages } from '../../pages/stay-in-the-loop-page/stay-in-the-loop-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/stay-in-the-loop-page/stay-in-the-loop-page.jsx')),
    path: ROUTES.STAY_IN_THE_LOOP,
    showFooter: false,
    showHeader: false,
    titleMessage: messages.titleMessage,
}
